<template>
  <div class="fund-management-container">
    <!-- 顶部导航栏 -->
    <div class="nav-bar">
      <img src="../assets/left-icon.png" alt="back" class="back-icon" @click="goBack" />
      <div class="nav-title">基金管理要素</div>
      <div class="nav-placeholder"></div>
    </div>

    <!-- 分成方式 -->
    <div class="section-card">
      <div class="section-title">分成方式</div>
      <div class="chart-wrapper">
        <div ref="donutChart" class="donut-chart"></div>
      </div>
    </div>

    <!-- 管理时限 -->
    <div class="section-card">
      <div class="section-title">管理时限</div>
      <div class="info-row">
        <span class="info-label">资金启动/结束时间</span>
        <span class="info-value" v-if="fundElements.start_date || fundElements.end_date">{{ (fundElements.start_date || '') +
          ' ~ ' + (fundElements.end_date || '') }}</span>
        <span v-else>-</span>
      </div>
      <div class="info-divider"></div>
      <div class="info-row">
        <span class="info-label">锁定期</span>
        <span class="info-value" v-if="fundElements.checkout_time">{{ (fundElements.checkout_time || '') +
          ' ~ ' + (fundElements.checkout_time || '') }}</span>
        <span v-else>-</span>
      </div>
      <div class="info-divider"></div>
      <div class="info-row">
        <span class="info-label">费后收益</span>
        <span class="info-value">{{ fundElements.after_profit || '-' }}</span>
      </div>
    </div>

    <!-- 结算方式 -->
    <div class="section-card">
      <div class="section-title">结算方式</div>
      <div class="info-row">
        <span class="info-label">结算方式</span>
        <span class="info-value">年度</span>
      </div>
      <div class="info-divider"></div>
      <div class="info-row">
        <span class="info-label">结算日期</span>
        <span class="info-value">{{ fundElements.checkout_time || '-' }}</span>
      </div>
      <div class="info-divider"></div>
      <div class="info-row">
        <span class="info-label">结算规则</span>
        <span class="info-value">-</span>
      </div>
    </div>
  </div>
</template>

<script>
import { systemFundElements } from '../api/apiList/system';
import * as echarts from 'echarts';

export default {
  name: 'FundManagement',
  data() {
    return {
      fundElements: {
        checkout_time: '',
        commitment: '',
        end_date: '',
        guaranteed: '',
        id: '',
        manage_fee: '',
        name: '',
        profit_show: '',
        revenue: '',
        settlement_method: '',
        settlement_rule: '',
        start_date: '',
        strategies: ''
      },
      chart: null
    }
  },
  mounted() {
    this.getFundElements()
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
  methods: {
    async getFundElements() {
      let info = await systemFundElements()
      this.fundElements = {
        ...info.data,
        after_profit: info.after_profit
      }
      this.$nextTick(() => {
        this.drawDonutChart();
      });
    },
    goBack() {
      this.$router.back();
    },
    drawDonutChart() {
      if (this.chart) {
        this.chart.dispose();
      }
      this.chart = echarts.init(this.$refs.donutChart);

      const data = [
        { value: parseFloat(this.fundElements.revenue) || 0, name: '客户收益', itemStyle: { color: '#36D8AF' } },
        { value: parseFloat(this.fundElements.commitment) || 0, name: '业绩提成', itemStyle: { color: '#E8C547' } },
        { value: parseFloat(this.fundElements.manage_fee) || 0, name: '管理费率', itemStyle: { color: '#4A9EFF' } }
      ];

      const option = {
        backgroundColor: 'transparent',
        legend: {
          orient: 'horizontal',
          bottom: '5%',
          left: 'center',
          itemGap: 15,
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            color: '#999',
            fontSize: 12
          },
          formatter: (name) => {
            const item = data.find(d => d.name === name);
            return `${name}  ${item.value}%`;
          }
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: '#36D8AF',
          borderWidth: 1,
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          formatter: '{b}: {c}%'
        },
        series: [
          {
            type: 'pie',
            radius: '45%',
            center: ['50%', '40%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: 'outside',
              color: '#fff',
              fontSize: 12,
              formatter: '{b}\n{c}%'
            },
            labelLine: {
              show: true,
              length: 15,
              length2: 10,
              lineStyle: {
                color: '#666'
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 14,
                fontWeight: 'bold'
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            data: data
          }
        ]
      };

      this.chart.setOption(option);
    }
  }
};
</script>

<style scoped>
.fund-management-container {
  width: 100%;
  min-height: 100vh;
  background-color: #000;
  color: #fff;
  padding: 0 0 20px;
  overflow: auto;
}

/* 顶部导航栏 */
.nav-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  position: sticky;
  top: 0;
  background-color: #000;
  z-index: 100;
}

.back-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.nav-title {
  font-size: 17px;
  font-weight: 500;
  color: #fff;
}

.nav-placeholder {
  width: 20px;
}

/* 卡片容器 */
.section-card {
  background-color: #1b1b1b;
  border-radius: 16px;
  padding: 20px 20px 0;
  margin: 0 20px 20px;
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 10px;
}

/* 圆环图 */
.chart-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.donut-chart {
  width: 100%;
  height: 300px;
}

.chart-center-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 28px;
  font-weight: 600;
  color: #fff;
}

/* 图例 */
.legend-container {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 20px 0;
}

.legend-item {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
}

.legend-dot {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  flex-shrink: 0;
}

.legend-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.legend-label {
  font-size: 12px;
  color: #999;
}

.legend-value {
  font-size: 14px;
  font-weight: 500;
  color: #fff;
}

/* 信息行 */
.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
}

.info-label {
  font-size: 14px;
  color: #999;
}

.info-value {
  flex-shrink: 0;
  font-size: 14px;
  color: #fff;
  text-align: right;
}

.info-divider {
  height: 1px;
  background-color: #2a2a2a;
}
</style>
